import type { ReactNode } from 'react';
import SameTabLink from '@/components/common/SameTabLink';
import { legalRoutes } from '@/config/legal';

interface LegalPageShellProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  showTermsLink?: boolean;
  showPrivacyLink?: boolean;
}

export default function LegalPageShell({
  title,
  subtitle,
  children,
  showTermsLink = true,
  showPrivacyLink = true,
}: LegalPageShellProps) {
  return (
    <div className="pt-[4.25rem] sm:pt-20 lg:pt-24 pb-10 sm:pb-14 lg:pb-16 bg-gray-50 min-h-screen">
      <div className="page-container max-w-5xl">
        <div className="bg-white rounded-lg sm:rounded-xl shadow-sm border border-gray-200 p-4 sm:p-8 lg:p-12">
          <header className="mb-6 sm:mb-8 lg:mb-10 border-b border-gray-200 pb-4 sm:pb-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">{title}</h1>
            {subtitle && <p className="mt-1.5 sm:mt-2 text-sm sm:text-base text-gray-500">{subtitle}</p>}
          </header>

          <div className="legal-content text-gray-800 leading-relaxed">{children}</div>

          {(showTermsLink || showPrivacyLink) && (
            <div className="mt-8 sm:mt-10 lg:mt-12 pt-4 sm:pt-6 border-t border-gray-200 flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm text-gray-600">
              {showTermsLink && (
                <SameTabLink to={legalRoutes.termsConditions} className="hover:text-orange-500 transition-colors">
                  Terms &amp; Conditions
                </SameTabLink>
              )}
              {showTermsLink && showPrivacyLink && <span className="text-gray-400">|</span>}
              {showPrivacyLink && (
                <SameTabLink to={legalRoutes.privacyPolicy} className="hover:text-orange-500 transition-colors">
                  Privacy Policy
                </SameTabLink>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
